<form class="filter" #formElement [formGroup]="form">
    <mat-form-field class="medium-width margin-right-small">
        <input matInput autocomplete="off" formControlName="from" [matDatepicker]="pickerFrom" placeholder="Fecha desde">
        <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
        <mat-datepicker #pickerFrom></mat-datepicker>

    </mat-form-field>
    <mat-form-field class="medium-width">
        <input matInput autocomplete="off" formControlName="to" [matDatepicker]="pickerTo" placeholder="Fecha hasta">
        <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
        <mat-datepicker #pickerTo></mat-datepicker>

    </mat-form-field>
    <mat-form-field class="medium-width margin-right-small">
        <input matInput autocomplete="off" formControlName="confirmatedFrom" [matDatepicker]="pickerConfirmatedFrom" placeholder="Fecha confirmado desde">
        <mat-datepicker-toggle matSuffix [for]="pickerConfirmatedFrom"></mat-datepicker-toggle>
        <mat-datepicker #pickerConfirmatedFrom></mat-datepicker>

    </mat-form-field>
    <mat-form-field class="medium-width">
        <input matInput autocomplete="off" formControlName="confirmatedTo" [matDatepicker]="pickerConfirmatedTo" placeholder="Fecha confirmado hasta">
        <mat-datepicker-toggle matSuffix [for]="pickerConfirmatedTo"></mat-datepicker-toggle>
        <mat-datepicker #pickerConfirmatedTo></mat-datepicker>

    </mat-form-field>
    <mat-form-field class="medium-width margin-right-small">
        <input type="text" #client matInput placeholder="Entidades" formControlName="entity" [matAutocomplete]="autEntity">
        <mat-autocomplete #autEntity="matAutocomplete" [displayWith]="filterCompleteEntity.displayFn">
            <mat-option *ngFor="let entity of filteredEntityOptions | async" [value]="entity">
                {{ entity.Name }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
    <mat-form-field class="medium-width margin-right-small">
        <input type="text" #client matInput placeholder="Planes" formControlName="plan" [matAutocomplete]="autPlan">
        <mat-autocomplete #autPlan="matAutocomplete" [displayWith]="filterCompletePlan.displayFn">
            <mat-option *ngFor="let plan of filteredPlanOptions | async" [value]="plan">
                {{ plan.Name }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
    <mat-form-field class="full-width">
        <input type="text" #client matInput placeholder="Médico" formControlName="physician" [matAutocomplete]="autPhysician">
        <mat-autocomplete #autPhysician="matAutocomplete" [displayWith]="filterCompletePhysician.displayFn">
            <mat-option *ngFor="let physician of filteredPhysicianOptions | async" [value]="physician">
                {{ physician.Name }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>

    <mat-form-field class="medium-width margin-right-small">
        <mat-select placeholder="Estados" formControlName="states" multiple>
            <mat-select-trigger>
                {{ f.states.value?.length > 0 ? f.states.value[0].Name : '' }}
                <span *ngIf="f.states.value?.length > 1" class="additional-selection">
                (+{{f.states.value.length - 1}} {{f.states.value?.length === 2 ? 'otra' : 'otros'}})
              </span>
            </mat-select-trigger>
            <mat-option *ngFor="let state of states" [value]="state">
                {{ state.Name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="medium-width">
        <input type="text" #client matInput placeholder="Período pago" formControlName="period" [matAutocomplete]="autPeriod">
        <mat-autocomplete #autPeriod="matAutocomplete" [displayWith]="filterCompleteMedicalFeeBillPeriod.displayFn">
            <mat-option *ngFor="let period of filterCompleteMedicalFeeBillPeriodOptions | async" [value]="period">
                {{ period.Name }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>



    <mat-form-field class="full-width">
        <input type="text" matInput placeholder="Protocolo" formControlName="protocol">
    </mat-form-field>
    <div>
        <mat-checkbox formControlName="orderByPracticeRegion"><span>Ordenar por práctica región</span> </mat-checkbox>
    </div>
</form>